import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { AdminMe, AdminSessionState } from '@hoopify/shared';
import { api } from './api';

/** Admin console data lives under query keys starting with "admin". */
export const adminSessionKey = ['admin', 'session'] as const;

export function useAdminSession() {
  return useQuery({ queryKey: adminSessionKey, queryFn: () => api.get<AdminSessionState>('/admin/session'), staleTime: 30_000 });
}

export function useAdmin(): AdminMe {
  const { data } = useAdminSession();
  if (data?.status !== 'signed_in') throw new Error('useAdmin used outside the admin console');
  return data.admin;
}

export function useSetAdminSession() {
  const qc = useQueryClient();
  return (state: AdminSessionState) => {
    if (state.status !== 'signed_in') qc.removeQueries({ predicate: (q) => q.queryKey[0] === 'admin' && q.queryKey[1] !== 'session' });
    qc.setQueryData(adminSessionKey, state);
  };
}

export const ACCOUNT_FILTER_LABELS = {
  all: 'All accounts',
  head_coaches: 'Head coaches',
  suspended: 'Suspended',
  unconfirmed: 'Email not confirmed',
  no_mfa: 'No two-step sign-in',
} as const;

export const TEAM_FILTER_LABELS = { active: 'Active', archived: 'Archived', all: 'All teams' } as const;
